import { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Amplify } from 'aws-amplify'
import { getCurrentUser } from 'aws-amplify/auth'
import { awsConfig } from './aws-config'
import { OrgProvider } from './contexts/OrgContext'
import { ThemeProvider } from './contexts/ThemeContext'

// Configure Amplify
Amplify.configure(awsConfig)

// Pages
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import ClientsPage from './pages/ClientsPage'
import CardsPage from './pages/CardsPage'
import EventsPage from './pages/EventsPage'
import DevicesPage from './pages/DevicesPage'
import UsersPage from './pages/UsersPage'
import SystemAdminPage from './pages/SystemAdminPage'
import Layout from './components/Layout'

function App() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    checkAuth()
  }, [])

  async function checkAuth() {
    try {
      const currentUser = await getCurrentUser()
      setUser(currentUser)
    } catch (error) {
      setUser(null)
    } finally {
      setLoading(false)
    }
  }

  function handleSignOut() {
    setUser(null)
  }

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    )
  }

  return (
    <ThemeProvider>
      <Router>
        {!user ? (
          <Routes>
            <Route path="/login" element={<LoginPage onSignIn={checkAuth} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        ) : (
          <OrgProvider>
            <Layout user={user} onSignOut={handleSignOut}>
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/clients" element={<ClientsPage />} />
                <Route path="/cards" element={<CardsPage />} />
                <Route path="/events" element={<EventsPage />} />
                <Route path="/devices" element={<DevicesPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/system-admin" element={<SystemAdminPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </OrgProvider>
        )}
      </Router>
    </ThemeProvider>
  )
}

export default App
